
import { FC, useCallback, useState } from 'react';
import { KeyboardArrowUp, KeyboardArrowDown, KeyboardArrowRight, Add } from '@mui/icons-material';
import * as types from '@models/types';

import '../CountryDetails.scss';

type TopSkillsProps = {
    id?: string;
    topSkills: types.TopSkillsTypes[];
    skillType?: string;
};

const TopSkills: FC<TopSkillsProps> = ({ id, topSkills, skillType }) => {
    const [hoverSkills, setHoverSkills] = useState<string | undefined>("");

    const handleSkillsMouseOver = (e: React.MouseEvent<HTMLDivElement>) => {
        setHoverSkills(e.currentTarget.dataset.name)
    }
    const handleSkillsMouseOut = () => {
        setHoverSkills("")
    }

    const transformToCamelCase = useCallback((text) => {
        var textSplitted: string[] = text.split(' ');
        var camelCasedTextArr = textSplitted.map((word: string) => {
            if (word.length > 1) {
                return word[0].toUpperCase() + word.substring(1, word.length);
            }
            else {
                return word.toUpperCase();
            }
        });
        return camelCasedTextArr.join(' ');
    }, []);

    return topSkills && <>
        <div {...(id ? { id: id } : {})}
            className="d-flex justify-content-around mb-4 mt-4">
            {topSkills.map((e, i) => {
                if (i === topSkills.length - 1) {
                    return <div className="occupation-tab__top-skills--col" key={e.year}>
                        <h4>{e.year}</h4>
                        {e.skills.map((result: types.TopSkillsObjTypes, currentIndex: number) => {
                            const prevSkills = topSkills[(topSkills.length > 1) ? topSkills.length - 2 : 0].skills
                            const prevSkillsEntry = prevSkills.find((n: types.TopSkillsObjTypes) => n.skill === result.skill)
                            const prevObjIndex = prevSkillsEntry ? prevSkills.indexOf(prevSkillsEntry) : -1
                            const prevVScurrent = (prevObjIndex < 0) ? 1000 : currentIndex - prevObjIndex

                            return <div key={currentIndex} onMouseOver={handleSkillsMouseOver} onMouseOut={handleSkillsMouseOut} className={hoverSkills === result.skill ? "selected" : ""} data-name={result.skill} {...(result.skillURI && { onClick: () => window.open(result.skillURI, "_blank"), role: "button" })}>
                                <div className="occupation-tab__top-skills--skill">
                                    {transformToCamelCase(result.skill)}
                                </div>
                                <i className="occupation-tab__top-skills--icons">
                                    {prevVScurrent === 1000 ? <Add className="text-info" /> : null}
                                    {prevVScurrent === 0 ? <KeyboardArrowRight className="text-primary" /> : null}
                                    {prevVScurrent < 0 ? <KeyboardArrowUp className="text-success" /> : null}
                                    {prevVScurrent > 0 && prevVScurrent !== 1000 ? <KeyboardArrowDown className="text-danger" /> : null}
                                </i>
                            </div>
                        })}
                    </div>
                }
                return (<div className="occupation-tab__top-skills--col" key={e.year}>
                    <h4>{e.year}</h4>
                    {e.skills.map((result: types.TopSkillsObjTypes, index: number) => <div key={index} onMouseOver={handleSkillsMouseOver} onMouseOut={handleSkillsMouseOut} className={hoverSkills === result.skill ? "selected" : ""} data-name={result.skill} {...(result.skillURI && { onClick: () => window.open(result.skillURI, "_blank"), role: "button" })}>
                        <div className="occupation-tab__top-skills--skill">
                            {transformToCamelCase(result.skill)}
                        </div>
                    </div>)}
                </div>)
            }
            )}
        </div>
        <div className="d-flex justify-content-center">
            <div className="border border-end-0 px-3"><Add className="text-info" /> New</div>
            <div className="border border-end-0 px-3"><KeyboardArrowUp className="text-success" /> Up</div>
            <div className="border border-end-0 px-3"><KeyboardArrowDown className="text-danger" /> Down</div>
            <div className="border px-3"><KeyboardArrowRight className="text-primary" /> Same</div>
        </div>
    </>
};

export default TopSkills;
